import React, { Component } from "react";

class CloseButton extends Component {
    render() {
        return (
            <>
            <span style={{position: "absolute", top: 6, right: 14}}>
                <span className="bm-cross" style={{position: "absolute", width: 3, height: 14, transform: "rotate(45deg)"}}></span>
                <span className="bm-cross" style={{position: "absolute", width: 3, height: 14, transform: "rotate(-45deg)"}}></span>
            </span>
            </>
        );
    }
}

export default CloseButton;
